import React, { useState } from "react";
import { useMutation } from "react-query";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
	searchPortalUser,
	clearMemberPassword,
} from "../../../api/apiServices";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import UserRoles from "../../../hooks/userRoles";
import useAuth from "../../../hooks/useAuth";
import jwt_decode from "jwt-decode";

const ResetMemberPassword = () => {
	const { auth } = useAuth();
	const decoded = auth?.accessToken
		? jwt_decode(auth.accessToken)
		: undefined;

	const role = decoded?.UserInfo?.role || "";

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/";

	const [search, setSearch] = useState(false);
	const [member, setMember] = useState({});

	const [state, setState] = useState({
		pf_number: "",
		mobile_number: "",
		first_name: "",
		last_name: "",
	});

	const handleOnChange = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		setState((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleMobileNumber = (value, countryObj, e, formattedValue) => {
		const name = e.target.name;
		setState((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleSearch = async (e) => {
		e.preventDefault();
		const searchData = {
			pf_number: state.pf_number,
			mobile_number: state.mobile_number,
			first_name: state.first_name,
			last_name: state.last_name,
		};
		searchMutation.mutate(searchData);
	};

	const searchMutation = useMutation(searchPortalUser, {
        onSuccess: async (res) => {
          
			if (res.status) {
				setMember(res.portal_user);
				setSearch(true);
			} else {
				toast.error(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				setMember([]);
				setSearch(false);
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
		},
	});
	const handleResetPswd = (pf_number, email) => {
		if (role === UserRoles.SuperAdmin || role === UserRoles.SystemAdmin) {
            const memberData = {
                pf_number: pf_number.toLocaleUpperCase(),
                email: email,
            }
            resetPasswordMutation.mutate(memberData);
		} else {
			toast.error(
				"You are not authorized to perform this function. Contact the System Administrator",
				{
					duration: 3000,
					className: "toast-message",
				}
			);
			return false;
		}
	};

	const resetPasswordMutation = useMutation(clearMemberPassword, {
		onSuccess: async (res) => {
			if (res.success) {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
                setSearch(false);
                setState({
					pf_number: "",
					mobile_number: "233",
					first_name: "",
					last_name: "",
				});
			} else {
				toast.error(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				setSearch(false);
				setState({
					pf_number: "",
					mobile_number: "233",
					first_name: "",
					last_name: "",
				});
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
		},
	});

	const handleCancel = () => {
		setSearch(false);
		setState({
			pf_number: "",
			mobile_number: "233",
			first_name: "",
			last_name: "",
		});
	};

	const searchContent = (
		<form onSubmit={handleSearch}>
			<div className="form-group row">
				<div className="col-sm-3">
					<input
						type="text"
						placeholder="PF Number"
						name="pf_number"
						value={state.pf_number}
						onChange={handleOnChange}
						className="form-control"
					/>
				</div>
				<div className="col-sm-3">
					<PhoneInput
						inputStyle={{
							fontSize: 16,
							width: "100%",
							height: 40,
						}}
						country={"gh"}
						countryCodeEditable={false}
						enableSearch={true}
						enableClickOutside={false}
						value={state.mobile_number}
						inputProps={{
							name: "mobile_number",
							autoFocus: true,
						}}
						onChange={(value, countryObj, e, formattedValue) =>
							handleMobileNumber(
								value,
								countryObj,
								e,
								formattedValue
							)
						}
					/>
				</div>
				<div className="col-sm-2">
					<input
						type="text"
						placeholder="FirstName"
						name="first_name"
						style={{ textTransform: "uppercase" }}
						onChange={handleOnChange}
						value={state.first_name}
						className="form-control"
					/>
				</div>
				<div className="col-sm-2">
					<input
						type="text"
						placeholder="LastName"
						style={{ textTransform: "uppercase" }}
						name="last_name"
						onChange={handleOnChange}
						value={state.last_name}
						className="form-control"
					/>
				</div>
				<div className="col-sm-2">
					<button type="submit" className="btn btn-success btn-block">
						{" "}
						<i className="fa fa-search"></i> Search Member
					</button>
				</div>
			</div>
		</form>
	);

	const content =
		!search && member?.length <= 0 ? (
			<div className="table-responsive lg">
				<table className="table table-bordered">
					<tbody>
						<tr>
							<td
								style={{
									fontSize: "20px",
									fontWeight: "700",
									color: "#000",
									textAlign: "center",
								}}
							>
								No User found with the requested parameter(s)
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		) : search && member?.length > 0 ? (
			<div className="table-responsive lg">
				<table className="table table-borderless table-hover table-striped">
					<thead className="align">
						<tr>
							<th scope="col">#</th>
							<th scope="col">PF Number</th>
							<th scope="col">Full Name</th>
							<th scope="col">Role</th>
							<th scope="col">Mobile Number</th>
							<th scope="col">Email</th>
							<th scope="col">Action</th>
						</tr>
					</thead>
					<tbody>
						{member?.map((mem, index) => (
							<tr key={index}>
								<td>{index + 1}</td>
								<td>{mem.pf_number}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{mem.first_name+" "+mem.middle_name+" "+mem.last_name}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{mem.role?.role_name.toLocaleUpperCase()}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{mem.mobile_number}
								</td>
								<td>{mem.email}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									<div
										style={{
											display: "inline-block",
											whiteSpace: "nowrap",
										}}
									>
										<Link
											onClick={() =>
												handleResetPswd(mem.pf_number, mem.email)
											}
											className="small"
										>
											<i className="fa fa-edit"></i> Reset
											Password
										</Link>
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		) : null;

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>Member Password Resetting</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										{searchContent}
									</div>
								</div>
							</div>
							{search ? (
								<>
									<div className="panel-body">{content}</div>
									<div className="panel-footer">
										<button
											className="btn btn-danger"
											onClick={handleCancel}
										>
											Cancel
										</button>
									</div>
								</>
							) : null}
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default ResetMemberPassword;
